import { RawSelect, OptionRawSelect } from "./RawSelect";

interface YearMonthSelectProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    availableDates: string[];
    placeholder?: string;
}

export function YearMonthSelect({
    value,
    onChange,
    label,
    availableDates,
    placeholder = "Select date",
}: YearMonthSelectProps) {
    const dateOptions: OptionRawSelect[] = availableDates.map((date) => {
        const [year, month] = date.split("-");
        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const monthName = monthNames[parseInt(month) - 1];

        return {
            label: `${monthName} ${year}`,
            value: date,
        };
    });

    const selectedOption =
        dateOptions.find((opt) => opt.value === value) || null;

    return (
        <RawSelect
            name={`${label.toLowerCase()}-date`}
            label={label}
            options={dateOptions}
            selected={selectedOption}
            onChange={(option) => {
                if (!Array.isArray(option) && option) {
                    onChange(option.value);
                } else {
                    onChange("");
                }
            }}
            testId={`${label.toLowerCase()}-date-filter`}
            placeholder={placeholder}
        />
    );
}
